/**
 * Created by anatoly on 03.07.2025
 */

const CupHintLogic = {
    type: "cup",
    priority: 1,

    chooseConfig: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const fix = location.getContinuousStage();

        if (fix >= 9) {
            return { delay: 3000, interval: 7000 };
        }

        if (fix >= 3) {
            return { delay: 3000, interval: 3000 };
        }

        return { delay: 3000, interval: 1000 };
    },

    findMove: function () {
        const config = this.chooseConfig();
        if (!config) {
            return;
        }

        if (!Merge2.current || !Merge2.current.isGameMode()) {
            return;
        }

        const units = Merge2.current.field.listAvailableUnits((unit) => {
            if (unit.getType() !== "energycup" || unit.isGrounded() || !unit.onGetView()) {
                return false;
            }

            const locked = unit.findComponent(LockedComponent);
            if (locked && locked.isLocked()) {
                return !locked.isUnlocking() && !locked.isBlocked();
            }

            return unit.findComponent(CupComponent).canSpend();
        });
        if (units.length) {
            const unit = units[0];
            const locked = unit.findComponent(LockedComponent);
            const target = locked && locked.isLocked() ? locked.view.button : unit.onGetView();

            return {
                type: CupHintLogic.type,
                delay: config.delay,
                interval: config.interval,
                target
            };
        }
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(CupHintLogic);